
function Message({content ,cssStyle}) {
  return (
    <div className={cssStyle}>{content}</div>
  )
}

export default Message